import { BrandEnum } from "../_common/enum/brand.enum";


export const originToBrand: Record<string, BrandEnum> = {
    "https://lowquotes.ie": BrandEnum.LowQuote,
    "https://www.lowquotes.ie": BrandEnum.LowQuote,
    "https://staging.lowquotes.ie": BrandEnum.LowQuote,
    "https://app.lowquotes.ie": BrandEnum.Low,
    "https://low.ie": BrandEnum.Low,
    "https://www.low.ie": BrandEnum.Low,
    "https://hello.lowquotes.ie": BrandEnum.Hello,
    "https://hello.ie": BrandEnum.Hello,
    "https://www.hello.ie": BrandEnum.Hello,
    "http://hello.ie": BrandEnum.Hello,
    "https://truewealth.ie": BrandEnum.TrueWealth,
    "https://0joqgia.sitepreviewer.ie": BrandEnum.LowQuote,
    "http://0joqgia.sitepreviewer.ie": BrandEnum.LowQuote,
    "http://sitepreviewer.ie": BrandEnum.LowQuote,
    "https://sitepreviewer.ie": BrandEnum.LowQuote
};


export function resolveBrandFromUrl(rawUrl: string): BrandEnum | undefined {
    if (!rawUrl) return undefined;

    try {
        const origin = new URL(rawUrl).origin;
        if (originToBrand[origin]) {
            return originToBrand[origin];
        }
    } catch {
        // fall through for non-URL strings
    }

    const normalized = rawUrl.replace(/\/+$/, "");
    if (originToBrand[normalized]) {
        return originToBrand[normalized];
    }

    return undefined;
}

